import { StudyAdversaryProfile, StudyTimeHorizon } from '@@types/api.types';
import { getStudyAdversaryProfileLabel, getStudyTimeHorizonLabel } from '@utils/meia-enum.util';

export const STUDY_ADVERSARY_PROFILE_OPTIONS = Object.values(StudyAdversaryProfile).map((value) => ({
  label: getStudyAdversaryProfileLabel(value),
  value,
}));

export const STUDY_TIME_HORIZON_OPTIONS = Object.values(StudyTimeHorizon).map((value) => ({
  label: getStudyTimeHorizonLabel(value),
  value,
}));
